import * as Colors from '@wandb/weave/common/css/color.styles';
// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@wandb/weave/components/Form/TextField';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner} from '../../../Banner';
import {FixedSizeTextArea} from '../../../Form/FixedSizeTextArea';

export const CreateTriggerDrawer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
CreateTriggerDrawer.displayName = 'S.CreateTriggerDrawer';

export const CreateTriggerDrawerMain = styled.div`
  flex: 1 1 auto;
  padding: 4px;
  padding-bottom: 24px;
  overflow-y: auto;
`;
CreateTriggerDrawerMain.displayName = 'S.CreateTriggerDrawerMain';

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  padding: 20px 0px;
`;
Header.displayName = 'S.Header';

export const CloseButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
CloseButton.displayName = 'S.CloseButton';

export const PageLabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
  font-weight: 600;
  color: ${Colors.MOON_500};
`;
PageLabelRow.displayName = 'S.PageLabelRow';

export const Description = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
`;
Description.displayName = 'S.Description';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const Footer = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;
Footer.displayName = 'S.Footer';

export const FooterRightContent = styled.div`
  text-align: right;
  display: inline;
  min-width: 50px;
  flex: 1 0 50px;
  align-content: flex-end;
  vertical-align: middle;
`;
FooterRightContent.displayName = 'S.FooterRightContent';

export const FooterLeftContent = styled.div`
  text-align: right;
  display: inline;
  min-width: 50px;
  flex: 0 1 50px;
  align-content: flex-start;
  vertical-align: middle;
`;
FooterLeftContent.displayName = 'S.FooterLeftContent';

export const Help = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  color: ${Colors.MOON_600};
`;
Help.displayName = 'S.Help';

export const HelpMessage = styled.div`
  color: ${Colors.MOON_600};
`;
HelpMessage.displayName = 'S.HelpMessage';

export const TemplateHelperRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 4px;
  justify-content: space-between;
  flex-wrap: wrap;
`;
TemplateHelperRow.displayName = 'S.TemplateHelperRow';

export const TemplateHelperKey = styled.div`
  flex: 1;
`;
TemplateHelperKey.displayName = 'S.TemplateHelperKey';

export const TemplateHelperString = styled.div`
  flex: 1;
  overflow: wrap;
`;
TemplateHelperString.displayName = 'S.TemplateHelperString';

export const SuccessfulQueue = styled.div`
  display: flex;
  align-items: center;
`;
SuccessfulQueue.displayName = 'S.SuccessfulQueue';

export const SuccessfulQueueMessage = styled.div`
  margin-left: 8px;
`;
SuccessfulQueueMessage.displayName = 'S.SuccessfulQueueMessage';

export const Error = styled.div`
  color: ${Colors.RED_500};
  font-size: 14px;
`;
Error.displayName = 'S.Error';

export const Divider = styled.div`
  background-color: ${Colors.MOON_250};
  height: 1px;
  margin-left: -20px;
  margin-right: -20px;
`;

export const PlainText = styled.div`
  margin-top: 16px;
`;

export const StyledTextField = styled(TextField)`
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
StyledTextField.displayName = 'S.StyledTextField';

export const StyledTextArea = styled(FixedSizeTextArea)`
  min-height: 100px;
`;
StyledTextArea.displayName = 'S.StyledTextArea';

export const BannerWithMargin = styled(Banner)`
  margin: 20px 0 16px 0;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';

export const AutomationDescription = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  min-height: 130px;
  gap: 8px;
`;
AutomationDescription.displayName = 'S.AutomationDescription';

export const AutomationDescriptionInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;
AutomationDescriptionInner.displayName = 'S.AutomationDescriptionInner';

export const AutomationDescriptionBorder = styled.div`
  margin-right: 8px;
  width: 2px;
  background-color: ${Colors.TEAL_450};
  border-radius: 4px;
`;
AutomationDescriptionBorder.displayName = 'S.AutomationDescriptionBorder';

export const AutomationDescriptionSection = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${Colors.MOON_250};
  border-radius: 4px;
  width: 100%;
  min-height: 65px;
  padding: 8px 12px 8px 12px;
  background-color: white;
`;
AutomationDescriptionSection.displayName = 'S.AutomationDescriptionSection';

export const AutomationDescriptionIcon = styled.div`
  padding: 10px;
  margin-right: 8px;
  align-self: center;
`;
AutomationDescriptionIcon.displayName = 'S.AutomationDescriptionIcon';

export const AutomationDescriptionBody = styled.div`
  flex-direction: column;
`;
AutomationDescriptionBody.displayName = 'S.AutomationDescriptionBody';

export const AutomationDescriptionText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
AutomationDescriptionText.displayName = 'S.AutomationDescriptionText';

export const AutomationDescriptionTitle = styled.div`
  font-weight: 600;
  color: ${Colors.MOON_450};
  font-size: 16px;
  line-height: 24px;
`;
AutomationDescriptionTitle.displayName = 'S.AutomationDescriptionTitle';

export const SelectOption = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
SelectOption.displayName = 'S.SelectOption';

export const SelectOptionLabel = styled.div`
  display: flex;
  flex-direction: column;
`;
SelectOptionLabel.displayName = 'S.SelectOptionLabel';

export const SelectOptionLabelText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
SelectOptionLabelText.displayName = 'S.SelectOptionLabelText';

export const SelectOptionSubLabelText = styled.span`
  font-size: 14px;
  color: ${Colors.MOON_500};
  line-height: 20px;
`;
SelectOptionSubLabelText.displayName = 'S.SelectOptionSubLabelText';

export const SelectOptionInfoText = styled.span`
  font-size: 14px;
  color: ${Colors.MOON_500};
  line-height: 140%;
`;
SelectOptionInfoText.displayName = 'S.SelectOptionInfoText';

export const ErrorText = styled.div`
  margin-top: 8px;
  color: ${Colors.RED_600};
  line-height: 24px;
`;
ErrorText.displayName = 'S.ErrorText';
